import { createSelector } from 'reselect';
import { getUi } from '../rootSelectors';

const getNotifications = createSelector([getUi], ui => ui.notifications);

const getConfirmations = createSelector([getUi], ui => ui.confirmations);

export { getNotifications, getConfirmations };
